import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getSFTPWriterTourSteps({
	defaultStyles,
	microTaskConfigType,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	if (!microTaskConfigType) return [];

	return [
		{
			id: 'sftp-host',
			selector: '[data-tour="sftp-host"]',
			content:
				'The DNS name or IP address of the SFTP server the task will connect to. This property also supports expressions. See the Expression Selector for more information.',
		},
		{
			id: 'sftp-port',
			selector: '[data-tour="sftp-port"]',
			content:
				'The port number of the SFTP server the task will connect to. The default port is 22.',
		},
		{
			id: 'sftp-authentication-type',
			selector: '[data-tour="sftp-authentication-type"]',
			content:
				'The authentication method used when connecting to the SFTP server. Supported options are Password or SSH.',
		},
		{
			id: 'sftp-username',
			selector: '[data-tour="sftp-username"]',
			content:
				'The user account used to log in to the SFTP server. This property also supports expressions. See the Expression Selector for more information.',
		},
		{
			id: 'sftp-password-private-key',
			selector: '[data-tour="sftp-password-private-key"]',
			content:
				'The password or private key associated with the SFTP server user. This value is populated via a Flow Parameter of type Passphrase.',
		},
		{
			id: 'sftp-directory',
			selector: '[data-tour="sftp-directory"]',
			content:
				'The directory on the SFTP server that the task will write/upload files to. This property also supports expressions. See the Expression Selector for more information.',
		},
		{
			id: 'sftp-test-connection',
			selector: '[data-tour="sftp-test-connection"]',
			content:
				'Runs a connection test to verify that the task can connect to the SFTP server and has the required permissions.',
		},
		{
			id: 'file-reader-configuration',
			selector: '[data-tour="file-reader-configuration"]',
			content:
				'Used to configure how files retrieved from the SFTP server will be read. See File Readers for more information on the available configuration options.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
